import { createRoot } from "react-dom/client";
import { App } from "./app";
import { ErrorBoundary } from "./ErrorBoundary";
import "./ui.css";

const el = document.getElementById("root");
if (!el) throw new Error("no #root");
createRoot(el).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
